<template>
 <div>
   <h1 @click="showSocketService()">
    Hello Operator {{ currentuser.wmid }}
   </h1>
   <fwb-modal v-if="isShowModalIframe" size="5xl" persistent>
      <template #header>
        <div class="flex items-center text-lg" style="color:white;">
          Звонок
        </div>
        <div style="color:white;cursor:pointer;" @click="closeModalCall()">
          &#10005;
        </div>
      </template>
      <template #body >
        <div class="uname">Имя: {{ currentcallname }}, Email: {{ currentcallemail }}, Телефон: {{ currentcallphone }}
          <p class="mes" :class="styleClass" @click="toggleMesLongClass()">Сообщение: {{ currentcallmessage }}</p>
        </div>
        <iframe allowusermedia v-bind:src="iframurl" style="width:100%;min-height: 400px;" allow="camera *;microphone *;display-capture *; autoplay *; clipboard-write *;fullscreen *;"></iframe>
      </template>
    </fwb-modal>
    <!-- <a href="#" class="button" @click="showCallModal()">
        Call
      </a> -->
   <!-- <div>
    1 = {{ socketconnected }}
   </div>
   <div>
    2 = {{ socketauthenticated }}
   </div> -->
   <div>
    <h2>Операторы онлайн:</h2>

    <div>
      {{ onlineoperators}}
    </div>
    <div v-for="operator in this.onlineoperators"  v-bind:key="operator">
      {{ operator.wmid }}
    </div>
   </div>
   <div class="buttoncontainer">
     <a href="#" class="buttongreen" @click="goToWork()" v-if="!socketauthenticated">
      Подключиться
     </a>
     <a href="#" class="buttonblue" @click="goDown()" v-if="socketauthenticated">
      Отключиться
     </a>
   </div>
   <div style="margin-top:60px;">
      <h1>
        Входящие звонки:
      </h1>
     <div style="margin-top:60px;display: flex;justify-content: center;" >
      <div class="callcontainer">
        <div v-for="incommingcall in this.incommingcalls" v-bind:key="incommingcall">
          <div class="incommingcallname">
            {{ incommingcall["id"] }}. Входящий звонок от:  {{ incommingcall["caller"]["name"] }} 
            <div>
              {{ incommingcall["caller"]["phone"] }} - {{ incommingcall["caller"]["email"] }}
            </div>
            <div>
              Сообщение: {{ incommingcall["data"]["message"] }}
            </div>
            <a href="#" class="buttongreen" @click="acceptCall(incommingcall['id'])">
              Принять
            </a>
            
          </div>
        </div>
      </div>
      </div>
   </div>
 </div>
</template>

<script>
// import RestResource from "../services/api";

import { throwStatement } from "@babel/types";
import {getSocketAuth, getOnlineUsers, createAnswer, getAllcalls, validateToken} from "../services/api";
import VueCookies from 'vue-cookies'

import { FwbModal } from 'flowbite-vue'

import socketioservice from '../services/socketioservice';

export default {
  name: 'OperatorSpace',
  props: {
    msg: String
  },
  components: {
    FwbModal
  },
  methods: {
    toggleMesLongClass(){
      if(this.styleClass == ''){
        this.styleClass = 'meslong'
      }else{
        this.styleClass = ''
      }
    },

    acceptCall(id){
      console.log(id);
      this.currentcallname = null;
      this.currentcallphone = null;
      this.currentcallemail = null;
      this.currentcallmessage = null;
        
      // this.currentcallid = id;
      createAnswer(id).then((res) => {
        console.log(res["callrequest"]["roomid"]);
        console.log("RESULT RESP: ", res);
        VueCookies.set('client', res.authdata.chattoken.client, '1d', '/', '.webmoney.com', true, 'None')
        VueCookies.set('expiry', res.authdata.chattoken.expiry, '1d', '/', '.webmoney.com', true, 'None')
        VueCookies.set('access-token', res.authdata.chattoken.token, '1d', '/', '.webmoney.com', true, 'None')
        VueCookies.set('uid', res.authdata.uid, '1d', '/', '.webmoney.com', true, 'None')
        VueCookies.set('token-type', 'Bearer', '1d', '/', '.webmoney.com', true, 'None')

        let newurl = "https://videochat.webmoney.com/?design=dark&novideo=true&roomid=" + res["callrequest"]["roomid"];
        this.iframurl = newurl;
        this.showCallModal();
        this.currentcallid = res['callrequest']['id'];


        this.currentcallname = res['callrequest']['caller']['name'];
        this.currentcallphone = res['callrequest']['caller']['phone'];
        this.currentcallemail = res['callrequest']['caller']['email'];
        this.currentcallmessage = res['callrequest']['message'];
        
      })
    },
    closeModalCall(){
      this.isShowModalIframe = false;
      this.iframurl = null;
      let closedata = {id: this.currentcallid}
      socketioservice.socket.emit("closeCallWindow", closedata);
      this.currentcallid = null;
    },
    showCallModal(){
      this.isShowModalIframe = true;
    },
    goOnlineOnSocket(user){
      console.log(user)
    },
    showSocketService(){
      console.log(socketioservice.socket);
    },
    getTokenFromServer(){
      getSocketAuth().then((res) => {
        this.sockettoken = res.token;
      })
    },
    clearCallQueue(mes){
      let data = JSON.parse(mes);
      this.incommingcalls.forEach((value, index) => {
        if(value["id"].toString() == data["id"]){
          this.incommingcalls.splice(index,1)
          // alert(data["id"]);
        }
      })
    },
    goToWork(){
      getSocketAuth().then((res) => {
        this.sockettoken = res.token;
        let msg = {}
        msg["token"] = this.sockettoken
        socketioservice.socket.emit("authenticate",msg)
      })
    },
    getCurrentUser(){
      validateToken().then((res) => {
        this.currentuser = res.data;
      })
    },
    goDown(){
      socketioservice.socket.emit("goout");
      // this.getOnlineOperators()
    },
    socketListener(){
      socketioservice.socket.on("connect", ()=>{
        this.socketconnected = true;
      })
      socketioservice.socket.on("wentoff", () =>{
        this.socketauthenticated = false;
        this.getOnlineOperators();
      })
      socketioservice.socket.on("authenticated", ()=>{
        console.log("GO authenticated!");
        this.socketauthenticated = true;
        this.getOnlineOperators()
      })
      socketioservice.socket.on("incommingCall", (message) => {
        console.log(message);
        let audio = new Audio('/call.wav'); // path to file
        console.log("AUDIO: ",audio)
        audio.play();
        this.incommingcalls.push(JSON.parse(message))
      })
      socketioservice.socket.on("callReseted", (message) => {
        console.log(message);
        let mes = JSON.parse(message);
        this.clearCallQueue(message);
        console.log("===== ", this.currentcallid, mes['id'])
        if(this.isShowModalIframe){
          if(this.currentcallid.toString() == mes['id'].toString()){
            this.closeModalCall()
          }
        }
      })
      socketioservice.socket.on("callAccepted", (message) => {
        console.log("CallAccepted: ",message);
        this.clearCallQueue(message);
      })
      socketioservice.socket.on("disconnect", ()=> {
        this.socketauthenticated = false;
        this.onlineoperators = [];
        this.socketconnected = false;
      })
    },
    getOnlineOperators(){
      getOnlineUsers().then((res) => {
        console.log(res.serverdata);
        this.onlineoperators = res.serverdata.operators;
      })
    }
  },
  mounted() {
    this.socketListener();
    this.getTokenFromServer();
    this.getCurrentUser();
  },
  data(){
    return {
      currentuser: {},
      sockettoken: {},
      socketauthenticated: false,
      socketconnected: false,
      onlineoperators: [],
      incommingcalls: [],
      iframurl: '',
      isShowModalIframe: false,
      currentcallid: '',
      styleClass: '',
      currentcallname: '',
      currentcallphone: '',
      currentcallemail: '',
      currentcallmessage: ''
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


.uname{
  color:white;
  font-size:10px;
  text-align: left;
}
.uname .mes{
  color:white;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis; /* This is where the magic happens. */
  cursor:pointer;
}
.uname .meslong{
  white-space: normal;
}

.incommingcallname{
  border:1px solid;
  padding:16px;
}
.buttoncontainer{
  display: flex;
  justify-content: center;
  align-items: center;
}
.buttongreen{
  cursor: pointer;
  /* display: flex;
  align-items: center;
  justify-content: center; */
  /* gap: 10px; */
  /* font-size: 14px; */
  background-image: linear-gradient(#81FBB8, #28C76F);
  color: white;
  border: solid 2px #42b983;
  /* height: 50px; */
  /* padding: 20px 20px; */
  border-radius: 5px;
  padding:10px;
  display:block;
  
  /* font-weight: 600;
  transform: scale(0.89);
  position: relative; */
}
.buttonblue{
  cursor: pointer;
  /* display: flex;
  align-items: center;
  justify-content: center; */
  /* gap: 10px; */
  /* font-size: 14px; */
  background-image: linear-gradient(#313ed7, #3470fa);
  color: white;
  border: solid 2px #42b983;
  /* height: 50px; */
  /* padding: 20px 20px; */
  border-radius: 5px;
  padding:10px;
  display:block;
  /* font-weight: 600;
  transform: scale(0.89);
  position: relative; */
}

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
